/**------------------------------------------------------
 * Socket Error Response
 */
export interface ISocketError {
	status	: boolean;
	code	: number;
	message	: string;
	error	: any;
}
